import actions from '../action/direct_sales'
import CONSTANT from '../constant/direct_sales'
import { Toast } from 'mint-ui'
export default {
    actions,
    state: {
        
    },
    getters: {

    },
    mutations: {
        [CONSTANT.DIRECT_SALES_GETDIRECTSALESMENUS_SUCCESS] (state, data) {
            
        },
        [CONSTANT.DIRECT_SALES_GETDIRECTSALESMENUS_ERROR] (state, e) {
            Toast({
                message: e,
                position: 'bottom',
                duration: 3000
            })
        },
        [CONSTANT.DIRECT_SALES_GETDIRECTSALESRECOMMEND_SUCCESS] (state, data) {
            
        },
        [CONSTANT.DIRECT_SALES_GETDIRECTSALESRECOMMEND_ERROR] (state, e) {
             Toast({
                message: e,
                position: 'bottom',
                duration: 3000
            })
        },
        /*yeoman-template-point-1*/
    }
}